<template>
  <div class="forget-password">
    <div class="login-head">
      <div class="login-logo">
        <img
          @click="returnLogin"
          :src="require('@/assets/img/logo.png')"
          alt="logo"
          height="40"
        />
        <span class="second-title">找回密码</span>
      </div>
    </div>
    <div class="login-content">
      <div class="login-tab">
        <div
          :class="
            templateType == 'mobileInfo'
              ? 'login-tab-item login-tab-active'
              : 'login-tab-item'
          "
          @click="handelLoginChange('mobileInfo')"
        >
          验证用户手机
        </div>
        <div
          :class="
            templateType == 'accountInfo'
              ? 'login-tab-item login-tab-active'
              : 'login-tab-item'
          "
        >
          重置密码
        </div>
      </div>
      <template v-if="templateType == 'mobileInfo'">
        <div class="input-label">手机号码</div>
        <div class="login-info user-name user-name-phone">
          <!-- <el-input v-model="forgetData.loginNamePre" class="login-input user-name-phone-pre"  autocomplete="off">
          </el-input> -->
          <el-input
            v-model="forgetData.loginName"
            class="login-input user-name-phone-num"
            :placeholder="'请输入手机号码'"
            autocomplete="off"
          >
          </el-input>
        </div>
        <div class="input-label">验证码</div>
        <div class="login-info user-code user-code-phone">
          <el-input
            v-model="forgetData.code"
            class="login-input"
            placeholder="请输入手机验证码"
            autocomplete="off"
          >
          </el-input>
          <el-button
            class="user-code-phone-suffix"
            @click="getMobileCode('forgetData')"
            type="text"
            >{{ buttonTexts.forgetData }}</el-button
          >
        </div>
        <div class="login-confirm">
          <el-button class="login-confirm-btn" @click="handleConfirm(0)"
            >下一步</el-button
          >
        </div>
      </template>
      <template v-if="templateType == 'accountInfo'">
        <div class="input-label">设置用户密码</div>
        <div class="login-info user-psw">
          <el-input
            v-model="forgetData.password"
            class="login-input"
            type="password"
            placeholder="请输入密码"
            autocomplete="off"
          >
          </el-input>
        </div>
        <div class="input-label">重复用户密码</div>
        <div class="login-info user-psw">
          <el-input
            v-model="forgetData.repassword"
            class="login-input"
            type="password"
            placeholder="请输入密码"
            autocomplete="off"
          >
          </el-input>
        </div>
        <div class="login-confirm">
          <el-button class="login-confirm-btn" @click="handleConfirm(1)"
            >立即找回密码</el-button
          >
        </div>
      </template>
    </div>
    <div class="login-bottom">
      ©2021 RenAnju 网约房管理平台| <span>服务协议</span>| 权利声明| 版本更新 |
      帮助中心| 问题反馈| 版权投诉
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import JSEncrypt from "jsencrypt";

export default {
  name: 'forgetPassword',
  data() {
    return {
      templateType: 'mobileInfo',
      account: '',
      password: '',
      code: '',
      phoneNum: '',
      forgetData: { loginNamePre: '86', loginName: '', password: '', code: '', repassword: '' },
      buttonTexts: { forgetData: '获取手机验证码', registerData: '获取验证码', mobileInfo: '获取手机验证码', },
      buttonDisabled: { forgetData: false, registerData: false, mobileInfo: false, },
    }
  },
  methods: {
    ...mapActions(['fetchData']),
    // tab切换
    handelLoginChange(templateType) {
      this.templateType = templateType
    },
    // 下一步或者确认
    handleConfirm(type) {
      if (this.forgetData.loginName.trim() == '') {
        this.$message.error('手机号不能为空')
        return false
      }
      if (this.forgetData.code.trim() == '') {
        this.$message.error('手机短信验证码不能为空')
        return false
      }
      if (type == 0) {
        this.templateType = 'accountInfo'
        return true
      }
      this.handleRestPwd()
    },
    // 数据加密
    getEncrypt(data) {
      let publickKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMKvDoYmZuEUIX5iG6b2b1GuJUYaqAMGm+NGGlTO59KP9ccqbW6KOSu0Cp3sewbXQnzIg5QxlKzySPH9p/SlnQIAT3eMhPRAj4iP6QZ8ZH6WzVquNTNZSHomQ03Pt/Ffx1AogBQVMgdMHFTN18L6kud3NSXGqqGx1ds+q5rrVYSwIDAQAB'
      let crypt = new JSEncrypt()
      crypt.setPublicKey(publickKey)
      let ret = crypt.encrypt(data)
      return ret
    },
    // 重置密码
    handleRestPwd() {
      if (this.forgetData.password.trim() == '') {
        this.$message.error('密码不能为空')
        return false
      }
      if (this.forgetData.password.trim() != this.forgetData.repassword.trim()) {
        this.$message.error('两次输入密码不一致！')
        return false
      }
      const url = 'USER.POST_FORGOT_PASSWORD'
      this.fetchData({
        url,
        params: { phoneNum: this.forgetData.loginName.trim(), password: this.getEncrypt(this.forgetData.password.trim()), verifyCode: this.forgetData.code },
        method: 'post',
      })
        .then((res) => {
          if (res && res.success) {
            this.$message.success('操作成功')
            this.$router.replace('/account/login')
          } else {
            this.$message.error(res.info || '操作失败')
          }
        })
        .catch((err) => {
          this.$message.error(err || '操作失败！')
        })
    },
    settime(time, type) {
      if (time == 0) {
        this.buttonDisabled[type] = false;
        this.buttonTexts[type] = "获取验证码";
        return;
      } else {
        this.buttonDisabled[type] = true;
        this.buttonTexts[type] = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.settime(time, type);
      }, 1000);
    },
    // 获取手机验证码
    getMobileCode(type) {
      if (this.buttonDisabled[type]) {
        return false
      }
      var phone = this[type].loginName;
      var reg = /^1\d{10}$/;
      if (phone === "") {
        this.$message.error('请输入手机号')
        return false;
      } else if (!reg.test(phone)) {
        this.$message.error('请输入正确格式的手机号！')
        return false;
      }
      const url = 'USER.POST_PHONE_CHECK_CODE'
      this.fetchData({
        url,
        params: { phoneNum: phone },
        method: 'post'
      })
        .then((res) => {
          if (res.success) {
            this.settime(60, type)
          } else {
            this.$message.error(res.info || '发送失败！')
          }
        })
    },
    // 返回登录
    returnLogin(){
      this.$router.replace('/account/login')
    }
  },
}
</script>
<style lang='less' scoped>
.forget-password {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  .login-head {
    border-bottom: 1px solid #ccc;
  }
  .login-logo {
    height: 40px;
    line-height: 20px;
    margin: 15px;
    margin-left: 25px;
    img {
      cursor: pointer;
    }
  }
  .second-title {
    display: inline-block;
    margin-left: 30px;
    margin-top: 10px;
    width: 100px;
    font-size: 16px;
    font-weight: bold;
    color: #666666;
    border-left: 1px solid #cccccc;
    padding-left: 20px;
  }
}
.login-content {
  width: 430px;
  margin: auto;
  .input-label {
    font-weight: bold;
    font-size: 16px;
    color: #000;
    padding: 5px 0px 15px 0px;
  }
  .login-info {
    margin-bottom: 15px;
    .login-input {
      width: 100%;
    }
    .el-image {
      margin: 8px;
      width: 24px;
      height: 24px;
    }
    /deep/ .el-input__inner {
      padding: 15px;
      border-radius: 8px;
      border: 1px solid #ccc;
      outline: none;
      height: 50px;

      height: 47px !important;
      border: solid 1px #cad2db !important;
      background: #fff;
      transition: background-color 50000s ease-in-out 0s;
      &:hover {
        border: 1px solid #ffc107 !important;
      }
      &:focus {
        border: 1px solid #00d2e1 !important;
        box-shadow: 0 0px 3px 0px #00d2e1;
      }
    }
  }
  .user-code .el-button {
    color: #3a9bff;
    font-size: 12px;
  }
  .user-name-phone,
  .user-code-phone {
    display: flex;
  }
  .user-name-phone-pre {
    width: 100px !important;
    margin-right: 10px;
  }
  .user-name-phone-num {
    flex: 1;
  }
  .user-code-phone-suffix {
    width: 135px;
    margin-left: 25px;
    text-decoration: none;
    color: #333 !important;
    font-size: 15px !important;
    &.el-button.el-button--default {
      padding: 0;
    }
  }

  .login-confirm {
    .login-confirm-btn {
      background: #00d2e1;
      color: #fff;
      width: 100%;
      cursor: pointer;
      margin-top: 20px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
      padding: 15px;
      height: 55px;
    }
  }
}
.login-tab {
  font-size: 10px;
  display: flex;
  justify-content: flex-start;
  padding: 40px 0px;
  .login-tab-item {
    margin-right: 30px;
    font-size: 14px;
    font-weight: normal;
    color: #999;
    line-height: 18px;
  }
  .login-tab-active {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    padding-top: 0px;
  }
}
.login-bottom {
  text-align: center;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
  color: #333;
  font-weight: 545;
  display: flex;
  justify-content: center;
  background: #fff;
}
</style>
